export function canManage(user, key) {
  const permission = user && user.permissions && user.permissions[key]
  return !!(permission && permission.manage === true)
}
